import React, { Component } from "react";
import { Panel } from "rc-easyui";
import MyNavbar from "../components/Navbar/MyNavbar";
import setTitle from "../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../helpers/cookieHelper";
import { API_URL } from "../constants";
import { isEmpty } from "../helpers/index";

const axios = require("axios");

export default class DashboardPage extends Component {
  constructor() {
    super();
    this.getTotalClients = this.getTotalClients.bind(this);

    this.state = {
      totalClients: "",
      totalActiveClients: "",
      permission:""
    };
  }

  componentDidMount() {
    setTitle("Dashboard");
    let data=getCookie('permission')
    this.setState({
      permission:JSON.parse(data)
    })
    this.getTotalClients();
  }

  async getTotalClients() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/gettotalclientdetail`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            //console.log("response",response);
            if (response.data.status === true) {
              this.setState({
                totalClients: response.data.object.totalClient,
                totalActiveClients: response.data.object.activeClient,
              });
            } else {
              alert(response.data.message);
              this.setState({
                totalClients: "-",
                totalActiveClients: "-",
              });
            }
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getTotalClients();
      }
    }
  }

  render() {
    const { totalClients, totalActiveClients,permission } = this.state;
    return (
      <div>
        <MyNavbar />
        {permission.includes('hrm') && permission.includes('project')? (
          <div>
        <h2 className='text-center py-4 '>
          <b> Welcome to Infox ERP Control Panel</b>
        </h2>
        <div className='container-fluid '>
          <div className='row'>
            <div className='col-6 '>
              <Panel
                title='Total Clients'
                bodyStyle={{ padding: 20 }}
                style={{ height: 120, width: 150, marginLeft: 400 }}
              >
                <h3>{totalClients}</h3>
              </Panel>
            </div>
            <div className='col-6 '>
              <Panel
                title='Total Active Clients'
                bodyStyle={{ padding: 20 }}
                style={{ height: 120, width: 150 }}
              >
                <h3>{totalActiveClients}</h3>
              </Panel>
            </div>
          </div>
        </div>
          </div>
        ):""}

      </div>
    );
  }
}
